import http from './http';

export function fetchSubscriptionDashboard() {
  return http.get('/subscriptions');
}

export function resetSubscriptionDayUsage(balanceId) {
  return http.post(`/subscriptions/${balanceId}/day-usage-reset`);
}
